import { InjectionToken } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL', {
  factory: () => environment.apiUrl,
});

export const HTTP_INTERCEPTORS = new InjectionToken<HttpInterceptorFn[]>('HTTP_INTERCEPTORS');
